import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SelectComponent } from './select.component';
import { ClickOutsideDirective } from './click-outside.directive';
import { ListFilterPipe } from './list-filter.pipe';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [SelectComponent, ClickOutsideDirective, ListFilterPipe],
  exports: [SelectComponent]
})
export class SelectModule {
  static forRoot(): ModuleWithProviders<SelectModule> {
    return {
      ngModule: SelectModule
    };
  }
}
